import { Injectable } from "@angular/core";
import { QueryEntity } from "@datorama/akita";
import { AnagraficaApparatoState, AnagraficaApparatoStore } from "./anagraficaApparato.store";

@Injectable({
  providedIn: 'root'
})
export class AnagraficaApparatoQuery extends QueryEntity<AnagraficaApparatoState> {
  constructor(protected store: AnagraficaApparatoStore) {
    super(store);
  }
}
